import { getDB } from "src/db/databases"
import { useCacheStore } from "src/stores/cacheStore"
import { Log } from "src/util/classes/log"
import { numberToPriorityClass } from "src/util/functions/misc"
import { getIssuePriority } from "src/util/http/csi/issuePriorities"
import { IssuePriority } from "src/util/types/dataModels/issuePriority"
import { PriorityClass } from "src/util/types/misc"

/**
 * Maps `issuePriority` to the css classname of the associated color.
 */
export function getIssuePriorityColor(issuePriority: IssuePriority): PriorityClass {
  return numberToPriorityClass(issuePriority.risk_factor)
}

export async function getIssuePriorityData(
  issuePriorityId: string
): Promise<IssuePriority | undefined> {
  try {
    const cacheStore = useCacheStore()

    const priorityInCache = cacheStore.issue_priority.get(issuePriorityId)

    if (priorityInCache) {
      return priorityInCache
    } else {
      const db = await getDB()
      const issuePriorityInDb = await db.issue_priority.findOne(issuePriorityId).exec()

      if (issuePriorityInDb) {
        const priorityMutable = issuePriorityInDb.toMutableJSON()
        cacheStore.issue_priority.set(priorityMutable.id, priorityMutable)
        return priorityMutable
      } else {
        return await getIssuePriority({}, issuePriorityId)
      }
    }
  } catch (error) {
    Log.error({
      message: "An error occurred while fetching Issue Priority data",
      error,
    })
  }
}
